import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AnimatePresence, motion } from 'framer-motion';

import { Link } from '@/common/components/link';
import { CONTACT_URL } from '@/common/constants';
import { styles } from './styles';

type Props = {
  show: boolean;
  title?: string;
  description?: string;
};

export const ErrorSection: FC<Props> = ({ show, title, description }) => {
  const [t] = useTranslation();
  return (
    <AnimatePresence initial={false}>
      {show && (
        <motion.div
          css={styles}
          initial='collapsed'
          animate='open'
          exit='collapsed'
          variants={{
            open: { height: 'auto' },
            collapsed: { height: 0 },
          }}
          transition={{ duration: 0.2 }}
        >
          <div className='error-section'>
            <div className='error-section__title'>{title || t('page.voucher.errorTitleNotRecognised')}</div>

            <div className='error-section__description'>
              {description || t('page.voucher.errorDescriptionNotRecognised')}
              <Link className='link' target='_blank' href={CONTACT_URL}>
                {t('page.voucher.errorLink')}
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
